import Tile from "../Tile";
import { grey } from "@mui/material/colors";
import Region from "../../Utility/Crud/Region";
import Term from "../../Utility/Crud/Term";
import PropTypes from "prop-types";
import MainContext from "../../Context/MainContext/MainContext";

export default class TileRegion extends Tile {
  static contextType = MainContext; // For legacy class components

  /**
   * @returns {string} The Region name.
   */
  getTitle() {
    return this.props.region
      ? Region.getDisplayName(this.props.region)
      : "None";
  }

  /**
   * @returns {string} The region type.
   */
  getSubtitle() {
    return this.props.region
      ? Term.getDisplayName(
          this.context.termsIndexed[this.props.region.regionTypeTermId],
        )
      : null;
  }

  /**
   * @returns {string} The string to be used by the avatar abbreviation
   * formatter.
   */
  getAvatarString() {
    return this.props.region ? Region.getDisplayName(this.props.region) : null;
  }

  /**
   * @returns {string} The color of the avatar.
   */
  getAvatarColor() {
    return this.props.region ? Region.getColor() : grey[400];
  }

  /**
   * Renders an icon to represent the avatar if no string is provided.
   */
  renderAvatarIcon() {
    return Region.getIcon();
  }
}
